import React from 'react';
import { Box, Grid } from '@mui/material';
import { DashboardCards } from './DashboardCards';
import { QuickAccess } from './QuickAccess';
import { RecentActivity } from './RecentActivity';

export const DashboardContent = ({ 
  dashboardSummaryData,
  recentActivities,
  onNavigate,
  onViewAllActivity,
  totalApis,
  remainingCredits,
}) => {
  return (
    <Box>
      {/* Dashboard Cards */}
      <Box sx={{ mb: 4 }}>
        <DashboardCards dashboardSummaryData={dashboardSummaryData}/>
      </Box>

      {/* Quick Access and Recent Activity */}
      <Grid container spacing={4}>
        <Grid item xs={12} lg={6}>
          <QuickAccess onNavigate={onNavigate} totalApis={totalApis} remainingCredits={remainingCredits} />
        </Grid>
        <Grid item xs={12} lg={6}>
        <RecentActivity 
            onViewAll={onViewAllActivity} 
            activities={recentActivities}
          />
        </Grid>
      </Grid>
    </Box>
  );
};